import type { StayScheduleDefaults } from "@/hooks/useStayScheduleDefaults";
import type { StayModule } from "./theme";

export type ReservationTimes = { checkInTime: string; checkOutTime: string };

export function getModuleScheduleDefaults(module: StayModule, defaults: StayScheduleDefaults): ReservationTimes {
  return module === "hotel"
    ? { checkInTime: defaults.hotelCheckInFrom, checkOutTime: defaults.hotelCheckOutFrom }
    : { checkInTime: defaults.daycareCheckInFrom, checkOutTime: defaults.daycareCheckOutFrom };
}

export function applyUntouchedScheduleDefaults(
  current: { checkInTime?: string | null; checkOutTime?: string | null },
  defaults: ReservationTimes,
): ReservationTimes {
  return {
    checkInTime: current.checkInTime || defaults.checkInTime,
    checkOutTime: current.checkOutTime || defaults.checkOutTime,
  };
}

export function nextCalendarDate(date: string): string {
  const next = new Date(`${date}T12:00:00`);
  next.setDate(next.getDate() + 1);
  const year = next.getFullYear();
  const month = String(next.getMonth() + 1).padStart(2, "0");
  const day = String(next.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}
